import type { Row, SortingFn, FilterFn } from '@tanstack/react-table';

/** Parse a currency-ish string ("2500.00", "$1,250.50") to a number; non-numeric -> 0. */
export function parseCurrency(value: unknown): number {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string') return 0;
  const cleaned = value.replace(/[$,\s]/g, '');
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
}

/**
 * TanStack sortingFn for string currency columns (numeric order).
 * Generic so it is assignable to a column's `SortingFn<TData>` for any row type.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- assignable to any column row type
export const currencySortingFn: SortingFn<any> = (a, b, columnId) =>
  parseCurrency(a.getValue(columnId)) - parseCurrency(b.getValue(columnId));

/**
 * Build a global-filter FilterFn that matches a case-insensitive substring
 * against the given row-object keys only.
 */
export function makeGlobalFilterFn<T>(searchKeys: (keyof T)[]): FilterFn<T> {
  return (row: Row<T>, _columnId, filterValue, _addMeta) => {
    const term = String(filterValue ?? '')
      .trim()
      .toLowerCase();
    if (!term) return true;
    return searchKeys.some(key => {
      const v = (row.original as T)[key];
      return v != null && String(v).toLowerCase().includes(term);
    });
  };
}
